import $ from 'jquery';

const $profileTabs = $('.js-profile-tabs a');

$profileTabs.on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
	$(this).tab('show');
});
